// extracted by mini-css-extract-plugin
export default {"su":"AppLayout__su___njsyh","content":"AppLayout__content____YUvw"};